import { render, staticRenderFns } from "./MyAddress.vue?vue&type=template&id=c2afef90&scoped=true&"
import script from "./MyAddress.vue?vue&type=script&lang=js&"
export * from "./MyAddress.vue?vue&type=script&lang=js&"
import style0 from "./MyAddress.vue?vue&type=style&index=0&id=c2afef90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2afef90",
  null
  
)

export default component.exports